import Rellax from 'rellax';

export default class ParallaxBg {
  static exec() {
    const els = document.querySelectorAll('[data-component="parallax-bg"]');
        els.forEach(function (el) {
            new ParallaxBg(el);
        });
  }

  constructor(el) {
    this.el = el;
    this.parallaxEl = this.el.querySelector('[data-el="parallax"]');
    this.bgEl = this.el.querySelector('[data-el="bg"]');
    this.bgEl.style.height = document.body.clientHeight * 0.8 + 'px';

    const rellax = new Rellax(this.parallaxEl, {
      speed: -10,
      center: false,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false,
    });
  }
}
